import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { Play, Clock, CheckCircle, AlertCircle } from 'lucide-react';
import api from '../utils/api';

const MyCourses = () => {
  const [enrollments, setEnrollments] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchMyCourses();
  }, []);

  const fetchMyCourses = async () => {
    try {
      const data = await api.get('/enrollments/my-courses');
      if (data.success) {
        setEnrollments(data.data);
      }
    } catch (error) {
      console.error('获取课程失败:', error);
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return (
      <div className="text-center py-12">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-primary-600 mx-auto"></div>
      </div>
    );
  }

  return (
    <div className="space-y-6">
      <h1 className="text-2xl font-bold">我的课程</h1>
      
      {enrollments.length === 0 ? (
        <div className="card p-12 text-center">
          <AlertCircle className="h-12 w-12 text-gray-400 mx-auto mb-4" />
          <p className="text-gray-500 mb-4">您还没有购买任何课程</p>
          <Link to="/courses" className="btn-primary">去浏览课程</Link>
        </div>
      ) : (
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {enrollments.map((enrollment) => (
            <Link
              key={enrollment._id}
              to={`/courses/${enrollment.course._id}`}
              className="card overflow-hidden hover:shadow-lg transition-shadow"
            >
              <div className="aspect-video bg-gray-200 relative">
                {enrollment.course.thumbnail ? (
                  <img
                    src={enrollment.course.thumbnail}
                    alt={enrollment.course.title}
                    className="w-full h-full object-cover"
                  />
                ) : (
                  <div className="w-full h-full flex items-center justify-center bg-gradient-to-br from-primary-100 to-primary-200">
                    <Play className="h-12 w-12 text-primary-400" />
                  </div>
                )}
                <div className="absolute bottom-0 left-0 right-0 bg-gradient-to-t from-black/70 to-transparent p-4">
                  <div className="w-full bg-gray-200 rounded-full h-2">
                    <div
                      className="bg-primary-600 h-2 rounded-full transition-all"
                      style={{ width: `${enrollment.overallProgress || 0}%` }}
                    />
                  </div>
                  <p className="text-white text-sm mt-1">已学习 {enrollment.overallProgress || 0}%</p>
                </div>
              </div>
              <div className="p-4">
                <h3 className="font-semibold text-lg mb-2">{enrollment.course.title}</h3>
                <div className="flex items-center justify-between text-sm text-gray-500">
                  <span className="flex items-center">
                    <Clock className="h-4 w-4 mr-1" />
                    {enrollment.course.stats?.totalLessons || 0} 课时
                  </span>
                  {enrollment.isCompleted ? (
                    <span className="flex items-center text-green-600">
                      <CheckCircle className="h-4 w-4 mr-1" />
                      已完成
                    </span>
                  ) : (
                    <span className="flex items-center text-primary-600">
                      <Play className="h-4 w-4 mr-1" />
                      继续学习
                    </span>
                  )}
                </div>
                {enrollment.validUntil && (
                  <p className="text-xs text-gray-400 mt-2">
                    有效期至：{new Date(enrollment.validUntil).toLocaleDateString()}
                  </p>
                )}
              </div>
            </Link>
          ))}
        </div>
      )}
    </div>
  );
};

export default MyCourses;
